import "shared/extensions/date";

import { UpdateUserCommand, UserResponseModel, useUpdateUserFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { useLocation, useNavigate } from "react-router-dom";

import { DestinationState } from "shared/core/state/destinationState";
import { NoValueSelected } from "shared/constants/SelectConstants";
import PersonalInfoForm, { Inputs, toPhoneFields } from "../Account/Components/PersonalInfoForm/PersonalInfoForm";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useUserContext } from "core/state/UserContext/UserContext";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { trackFormSubmission } from "core/monitoring/Events";

export const AdditionalInfo = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [errorMessage, setErrorMessage] = useState(false);
  const { trigger } = useUpdateUserFunctionRequest({});
  const navigateHook = useNavigate();
  const { isAdditionalInfoComplete, user: userData, saveUser } = useUserContext();

  const getDestination = (user: UserResponseModel) => {
    const hasInterests = (user.interests.length ?? 0) !== 0;
    let destination = DestinationState.get();
    destination = destination !== pathname ? destination : "/";
    return hasInterests ? destination : "/login/preferences";
  };

  if (isAdditionalInfoComplete() && userData) {
    navigateHook("/home", { replace: true });
    navigateHook(getDestination(userData));
    return null;
  }

  const onSubmit = async (additionalInfo: Inputs) => {
    setErrorMessage(false);
    const fullData: UpdateUserCommand = {
      forenames: additionalInfo.forenames,
      surname: additionalInfo.surname,
      dateOfBirth: additionalInfo.dateOfBirth.toDateOnly(),
      gender: additionalInfo.gender,
      divisionId: additionalInfo.divisionId === NoValueSelected ? undefined : additionalInfo.divisionId,
      ...toPhoneFields(additionalInfo.phone),
    };
    trackFormSubmission("Additional-Info");
    try {
      const user = (await trigger({ body: fullData }))?.data!;
      saveUser(user);
      navigate(user);
    } catch {
      setErrorMessage(true);
    }
  };

  const navigate = (user: UserResponseModel) => {
    navigateHook("/home", { replace: true });
    navigateHook(getDestination(user));
  };

  return (
    <div data-testid="additional-info-page">
      <PageTitle title={t("pageTitle.additionalInfo")} />
      <PersonalInfoForm onSubmit={onSubmit} errorMessage={errorMessage} user={userData} type={"additionalInfo"} />
    </div>
  );
};
